/**
 * Real countdown computed from a merchant-set end date (data-end, ISO
 * local datetime). Never fabricates numbers; shows the expired message
 * once the date has passed instead of looping or resetting.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var endValue = el.getAttribute('data-end');
    var end = new Date(endValue).getTime();
    if (isNaN(end)) return;

    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minutesEl = el.querySelector('[data-countdown-minutes]');
    var secondsEl = el.querySelector('[data-countdown-seconds]');
    var timerEl = el.querySelector('[data-countdown-timer]');
    var messageEl = el.querySelector('[data-countdown-message]');
    var expiredMessage = el.getAttribute('data-expired-message');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = Date.now();
      var diff = end - now;
      if (diff <= 0) {
        if (timerEl) timerEl.hidden = true;
        if (messageEl && expiredMessage) messageEl.textContent = expiredMessage;
        clearInterval(intervalId);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    var intervalId = setInterval(tick, 1000);
  });
})();
